import React from 'react';
import cx from 'classnames';
import { makeStyles } from 'tss-react/mui';
import { useMediaQuery } from 'ha/helpers/MediaQuery';
import { ImageList, ImageListProps } from '@hbf/dsl';
import { Theme } from '@mui/material';

import { COL_SPACING, CELL_HEIGHT } from './constants';

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    position: 'relative',
    paddingBottom: '66.66%', // 3:2
    height: 0,
  },
  gridList: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
  },
  imageList: {
    backgroundColor: theme.palette.grey[50],
  },
}));

interface Props {
  hasSecondCol?: boolean;
  autoHeight?: boolean;
  children: ImageListProps['children'];
}

export const ImageGridColContainer: React.FC<Props> = ({
  children,
  hasSecondCol,
  autoHeight = false,
}) => {
  const { md } = useMediaQuery();
  const { classes } = useStyles();
  const shouldApplyFixedRatio = autoHeight || !md || hasSecondCol;

  return (
    <div
      className={cx({
        [classes.root]: shouldApplyFixedRatio,
      })}
    >
      <ImageList
        rowHeight={shouldApplyFixedRatio ? 'auto' : CELL_HEIGHT.Desktop}
        className={cx(classes.imageList, {
          [classes.gridList]: shouldApplyFixedRatio,
        })}
        gap={COL_SPACING}
        cols={2}
      >
        {children}
      </ImageList>
    </div>
  );
};
